
import { Zap } from "lucide-react";

interface WeightStatusIndicatorsProps {
  isSyncing: boolean;
  lastSyncTime: number | null;
}

export const WeightStatusIndicators = ({ isSyncing, lastSyncTime }: WeightStatusIndicatorsProps) => {
  return (
    <>
      {/* Indicadores de estado ultra-optimizados */}
      {isSyncing && (
        <div className="absolute -top-1 -right-1 text-blue-400">
          <Zap className="w-3 h-3 animate-spin" />
        </div>
      )}
      {lastSyncTime && !isSyncing && lastSyncTime < 200 && (
        <div className="absolute -top-1 -right-3 text-green-400">
          <div className="w-2 h-2  bg-green-400 rounded-full"></div>
        </div>
      )}
    </>
  );
};
